import { Box, Tooltip } from "@mui/material";
import TrueFalseImage from "../TrueFalseImage";
import localize from "../../common/localize";
import { Circle } from "@mui/icons-material";

export default function WarningErrorStatus({
  currentValue,
  limitForWarning,
  limitForError,
  isSucceeded,
  isFailed,
  showStatusName,
}) {
  const getBackgroundColor = () => {
    if (limitForWarning === 0 && limitForError === 0) {
      return "#A5ACAA"; // gray
    }

    if (currentValue < limitForWarning) {
      return "#35D89C"; // green
    }

    if (currentValue >= limitForWarning && currentValue < limitForError) {
      return "#FFFF00"; // yellow
    }

    if (currentValue >= limitForError) {
      return "#F22353"; // red
    }

    return "#A5ACAA"; // gray
  };

  const getStatusName = () => {
    if (limitForWarning === 0 && limitForError === 0) {
      return localize.no_data;
    }

    if (currentValue < limitForWarning) {
      return localize.on_time;
    }

    if (currentValue >= limitForWarning && currentValue < limitForError) {
      return localize.next_to_be_delayed;
    }

    if (currentValue >= limitForError) {
      return localize.delayed;
    }

    return localize.no_data;
  };

  const getUI = () => {
    if (isSucceeded) {
      return <TrueFalseImage value />;
    }

    if (isFailed) {
      return <TrueFalseImage />;
    }

    return (
      <Box className="flex gap-2 items-center justify-center">
        <Tooltip title={getStatusName()}>
          <Circle
            sx={{
              color: `${getBackgroundColor()}`,
              width: "24px !important",
              height: "24px !important",
            }}
          />
        </Tooltip>

        {showStatusName && (
          <label className="text-xs" style={{ whiteSpace: "nowrap" }}>
            {getStatusName()}
          </label>
        )}
      </Box>
    );
  };

  return getUI();
}
